import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
import './index.css'

// core styles
import "./scss/volt.scss";
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage"; // Login or home page
import ScrollToTop from "./components/ScrollToTop";
// import PrivateRoute from "./components/PrivateRoute"; // Import PrivateRoute for protected routes

// // Pages for Routes
// import  from "./pages/Dashboard";
// import Signin from "./pages/Signin";
// import Signup from "./pages/Signup";
// import NotFound from "./pages/NotFound";

import PrivateRoute from "./components/PrivateRoute";
import DashboardOverview from "./pages/dashboard/DashboardOverview";
import Signin from "./pages/examples/Signin";
import Signup from "./pages/examples/Signup";
import VerifyEmail from "./pages/examples/VerifyEmail";
import NotFound from "./pages/examples/NotFound";
import MainLayout from "./components/MainLayout";
// import {Applications} from "./pages/Applications";
import Transactions from "./pages/Transactions";
import Settings from "./pages/Settings";
import Userlists from "./pages/Userlists";
import { ApplicationTable } from "./components/ApplicationTable";
import { UserlistTable } from "./components/Userlist";
import  Applications  from "./pages/Applications";
import BulkMessage from "./pages/components/BulkMessage";
import AutoReply from "./pages/components/AutoReply";
import FAQ from "./pages/components/FAQ";
import UserManual from "./pages/components/UserManual";
import EditApplication from "./pages/components/EditApplication";
import Addapplication from "./pages/components/Addapplication";
import Navs from "./pages/components/Navs";
import Navbar from "./components/Navbar";
import ViewApplication from "./pages/components/ViewApplication";

// Define your routes in the Switch
ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route exact path="/" component={Signin} />
      <Route exact path="/examples/sign-up" component={Signup} />
      <Route exact path="/verify-email" component={VerifyEmail} />
      {/* <Route exact path="/components/navs" component={Navs} /> */}
      {/* <Route exact path="/components/navbars" component={Navbar} /> */}
      {/* Use MainLayout to wrap the protected routes */}
      <MainLayout>
        {/* All routes that require authentication will go inside MainLayout */}
        <PrivateRoute exact path="/dashboard/overview" component={DashboardOverview} />
        <PrivateRoute exact path="/application" component={Applications} />
        <PrivateRoute exact path="/transactions" component={Transactions} />
        <PrivateRoute exact path="/user" component={Userlists} />
        <PrivateRoute exact path="/settings" component={Settings} />
        <PrivateRoute exact path="/components/bulkmessage" component={BulkMessage} />
        <PrivateRoute exact path="/components/auto_reply" component={AutoReply} />
        <PrivateRoute exact path="/components/faq" component={FAQ} />
        <PrivateRoute exact path="/components/usermanual" component={UserManual} />
        <PrivateRoute exact path="/components/editapplication/:id" component={EditApplication} />
        <PrivateRoute exact path="/components/addapplication" component={Addapplication} />
        <PrivateRoute exact path="/components/forms" component={Signup} />
        <PrivateRoute exact path="/components/viewapplication/:id" component={ViewApplication} />
        {/* <PrivateRoute exact path="/components/navs" component={Navs} /> */}
        {/* <PrivateRoute exact path="/components/navbars" component={Navbar} /> */}
        {/* <PrivateRoute exact path="/appTable" component={ApplicationTable} />
        <PrivateRoute exact path="/userList" component={UserlistTable} /> */}
      </MainLayout>
      <Route component={NotFound} /> {/* Fallback for undefined routes */}
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);
